<template>
  <div class="space-y-6">
    <h2 v-if="step.name" class="text-xl font-semibold mb-4">
      {{ step.name }}
    </h2>
    <p v-if="step.description" class="text-sm text-gray-600 mb-6">
      {{ step.description }}
    </p>

    <!-- Grid responsivo de campos usando Tailwind -->
    <div class="grid grid-cols-12 gap-4">
      <DynamicField
        v-for="field in visibleFields"
        :key="field.id"
        :field="field"
        :value="formData[field.name]"
        :submitted="submitted"
        :class="getFieldGridClass(field)"
        @input="(value) => $emit('update:field', field.name, value)"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { shouldShowField } from '@/utils/conditionEvaluator';
import { getFieldTailwindClass } from '@/utils/fieldMapper';
import DynamicField from './DynamicField.vue';

export default {
  name: 'DynamicStep',
  components: { DynamicField },
  props: {
    step: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    allFields: {
      type: Array,
      default: () => []
    },
    submitted: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:field'],
  setup(props) {
    // Filtra campos visíveis (baseado em condições)
    const visibleFields = computed(() => {
      if (!props.step.fields) return [];
      return props.step.fields.filter(field => shouldShowField(field, props.formData, props.allFields || []));
    });

    // Retorna classe CSS do grid baseado no layout do campo
    const getFieldGridClass = (field) => {
      return getFieldTailwindClass(field);
    };

    return {
      visibleFields,
      getFieldGridClass
    };
  }
};
</script>
